import Layout from '@layouts/withoutNaviagtion/withoutNavigationLayout';
import './map-vender.scss';
import { useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { getValue } from '@utils/lodash';
import Loader from '@components/common/Loader';
import InputField from '@_common/InputRuleFeild';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import { clientAdminFileUpload } from '@services/client-list.service';
import { toast } from 'react-toastify';
import TaskLicenseNavigation from '@components/Tasks/task-license-navigation';
import {
  addSpecificTaskLicenseTask,
  updateTaskLicenseTask,
} from '@services/license.service';
import { handleDownloadOnClick } from '@_common/downloadfile';
import PromptModal from '../../../../../../prompt/modal';
import { useCallbackPrompt } from '../../../../../../prompt/useCallbackPrompt';
import _ from 'lodash';
import NoAccessPage from '@components/common/NoAccess';
import { todayDate } from '@_common/date-helpers';
import TaskDetailsCommon from '@components/common/TaskDetails';
import CustomFileUpload from '@_common/custom-file-upload';
import { sanitizeInput } from '@_common/dompurify';
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  UncontrolledAccordion,
} from 'reactstrap';
import ApprovalFlowSvgComponent from '../../../../../../assets/svg-components/task-details/approval-flow';
import EntityMappingSvgComponent from '../../../../../../assets/svg-components/task-details/entity-mapping';

export default function TaskLicenseDetails(props: any) {
  let params = useParams();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const URLparams = Object.fromEntries(urlSearchParams.entries());
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [data, setData] = useState({});
  const [request, setRequest] = useState<any>({
    follow_up_date: '',
    renewal_reminder_date: '',
    expiry_date: '',
    completion_date: '',
    work_status: '',
    license_number: '',
    license_status: '',
    non_compliance_reason: '',
    is_no_expiry_task: false,
    document_ids: [
      {
        id: '',
      },
    ],
    assigned_user_id: '',
    assigned_evaluator: '',
    issuing_authority: '',
    issued_to: '',
    approved_status: '',
    entity_name: '',
  });
  const [dirtyFields, setDirtyFields] = useState<any>({
    follow_up_date: '',
    renewal_reminder_date: '',
    expiry_date: '',
    completion_date: '',
    work_status: '',
    license_number: '',
    license_status: '',
    non_compliance_reason: '',
    is_no_expiry_task: false,
    document_ids: [
      {
        id: '',
      },
    ],
    assigned_user_id: '',
    assigned_evaluator: '',
    issuing_authority: '',
    issued_to: '',
    approved_status: '',
    entity_name: '',
  });
  const [uploadedDocuments, setUploadedDocuments] = useState<any>([]);
  const [complianceStatusList] = useState([
    { value: 'PENDING', label: 'Pending' },
    { value: 'COMPLIED', label: 'Complied' },
    { value: 'NOT_APPLICABLE', label: 'Not Applicable' },
    { value: 'EXPIRED', label: 'Expired' },
    {value: 'ACTIVE',label:"Active"}
    // { value: "WORK_IN_PROGRESS", label: "Work In Progress" },
    // { value: "NON_COMPLIED", label: "Non Complied" },
    // { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
  ]);

  const [workStatus] = useState([
    { value: 'NEW', label: 'New' },
    { value: 'WORK_IN_PROGRESS', label: 'Work In Progress' },
    { value: 'COMPLETED', label: 'Completed' },
    {value:'RENEWAL_APPLIED',label:'Renewal Applied'},
        {value:'RENEWAL_PENDING',label:'Renewal Pending'}


  ]);

  const [daysList, setDaysList] = useState([]);
  const [reminder_date, setReminder_date] = useState<string | number | any>(
    '1',
  );

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getData();
    }
    let daysList: any = [];
    for (let i = 1; i < 31; i++) {
      daysList.push({
        value: i,
        label: i,
      });
    }
    [60, 90, 120].forEach((day) => {
      daysList.push({
        value: day,
        label: day,
      });
    });
    setDaysList(daysList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [info, setInfo] = useState({});
  const getData = async () => {
    try {
      setLoading(true);
      let resp = await addSpecificTaskLicenseTask(params.id);

      if (resp) {
        const licenseStatus = getValue(resp, `data.license_status`, '');
        const workStatus = getValue(resp, `data.work_status`, '');
        setInfo(getValue(resp, `data`, {}));
        setData(getValue(resp, `data.license`, {}));
        setRequest({
          ...request,
          follow_up_date: getValue(resp, `data.follow_up_date`, '')
            ? new Date(getValue(resp, `data.follow_up_date`, ''))
            : null,
          completion_date: getValue(resp, `data.completion_date`, '')
            ? new Date(getValue(resp, `data.completion_date`, ''))
            : new Date(),
          expiry_date: getValue(resp, `data.expiry_date`, '')
            ? new Date(getValue(resp, `data.expiry_date`, ''))
            : null,
          compliance_status: getValue(resp, `data.compliance_status`, ''),
          license_number: getValue(resp, `data.license_number`, ''),
          work_status: workStatus,
          license_status: licenseStatus,
          non_compliance_reason: getValue(
            resp,
            `data.non_compliance_reason`,
            '',
          ),
          is_no_expiry_task: getValue(resp, `data.is_no_expiry_task`, false),
          document_ids: getValue(resp, `documents`, []),
          assigned_user_id: getValue(resp, `data.assigned_to.id`, ''),
          assigned_evaluator: getValue(resp, `data.assigned_evaluator.id`, ''),
          issuing_authority: getValue(resp, `data.issuing_authority`, ''),
          issued_to: getValue(resp, `data.issued_to`, ''),
          approved_status: getValue(resp, `data.approved_status`, ''),
          entity_name: getValue(resp, `data.entity_name`, ''),
        });
        setDirtyFields({
          ...dirtyFields,
          follow_up_date: getValue(resp, `data.follow_up_date`, '')
            ? new Date(getValue(resp, `data.follow_up_date`, ''))
            : null,
          completion_date: getValue(resp, `data.completion_date`, '')
            ? new Date(getValue(resp, `data.completion_date`, ''))
            : new Date(),
          expiry_date: getValue(resp, `data.expiry_date`, '')
            ? new Date(getValue(resp, `data.expiry_date`, ''))
            : null,
          compliance_status: getValue(resp, `data.compliance_status`, ''),
          license_number: getValue(resp, `data.license_number`, ''),
          work_status: workStatus,
          license_status: licenseStatus,
          non_compliance_reason: getValue(
            resp,
            `data.non_compliance_reason`,
            '',
          ),
          is_no_expiry_task: getValue(resp, `data.is_no_expiry_task`, false),
          document_ids: getValue(resp, `documents`, []),
          assigned_user_id: getValue(resp, `data.assigned_to.id`, ''),
          assigned_evaluator: getValue(resp, `data.assigned_evaluator.id`, ''),
          issuing_authority: getValue(resp, `data.issuing_authority`, ''),
          issued_to: getValue(resp, `data.issued_to`, ''),
          approved_status: getValue(resp, `data.approved_status`, ''),
          entity_name: getValue(resp, `data.entity_name`, ''),
        });
        setUploadedDocuments(getValue(resp, `data.documents`, []));
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate: any = getValue(resp, `data.expiry_date`, '')
          ? new Date(getValue(resp, `data.expiry_date`, ''))
          : new Date();
        const secondDate: any = getValue(resp, `data.renewal_reminder_date`, '')
          ? new Date(getValue(resp, `data.renewal_reminder_date`, ''))
          : null;
        const diffDays = Math.round(
          Math.abs((firstDate - secondDate) / oneDay),
        );
        setReminder_date(diffDays ? diffDays : 1);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else if (
      getValue(uploadedDocuments, `length`, 0) === 0 &&
      (getValue(request, `license_status`, '') === 'EXPIRED' ||
        getValue(request, `license_status`, '') === 'COMPLIED' ||
        getValue(request, `license_status`, '') === 'ACTIVE')
    ) {
      toast.error('File upload is mandatory');
    } else {
      try {
        let obj = JSON.parse(JSON.stringify(request));
        var d =
          getValue(obj, `expiry_date`, '') &&
          new Date(getValue(obj, `expiry_date`, ''));
        d && d.setDate(d.getDate() - parseInt(reminder_date));

        let payload: any = {
          follow_up_date: getValue(obj, `follow_up_date`, '')
            ? todayDate(getValue(obj, `follow_up_date`, ''))
            : null,
          completion_date:
            getValue(obj, `license_status`, '') === 'COMPLIED' ||
              getValue(obj, `license_status`, '') === 'EXPIRED' ||
              getValue(obj, `license_status`, '') === 'ACTIVE' ||
              getValue(obj, `license_status`, '') === 'NOT_APPLICABLE'
              ? getValue(obj, `completion_date`, '')
                ? todayDate(getValue(obj, `completion_date`, ''))
                : moment(new Date()).format('YYYY-MM-DD')
              : null,
          expiry_date: getValue(obj, `expiry_date`, '')
            ? todayDate(getValue(obj, `expiry_date`, ''))
            : null,
          work_status: getValue(obj, `work_status`, ''),
          license_number: getValue(obj, `license_number`, ''),
          license_status: getValue(obj, `license_status`, ''),
          renewal_reminder_date: getValue(obj, `renewal_reminder_date`, '')
            ? todayDate(getValue(obj, `renewal_reminder_date`, ''))
            : d
              ? moment(new Date(d)).format('YYYY-MM-DD')
              : null,
          document_ids: uploadedDocuments.map((item: object) => ({
            id: getValue(item, `id`, ''),
          })),
          is_no_expiry_task: getValue(obj, `is_no_expiry_task`, false),
          assigned_to: getValue(obj, `assigned_user_id`, '') || null,
          assigned_evaluator: getValue(obj, `assigned_evaluator`, '') || null,
          issuing_authority: getValue(obj, `issuing_authority`, ''),
          issued_to: getValue(obj, `issued_to`, ''),
          approved_status: getValue(obj, `approved_status`, ''),
          entity_name: getValue(obj, `entity_name`, ''),
        };
        setSubmitLoading(true);
        let resp = await updateTaskLicenseTask(params.id, payload);
        if (resp) {
          setSubmitLoading(false);
          getData();
          confirmNavigation();
          toast.success('Updated successfully');
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: value,
    });
  };
  const handleUploadDocumnets = async (e: any) => {
    Array.from(e.target.files).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append('file', item);
      try {
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
      }
    });
  };

  const handleRemoveUploadedFiles = (id: string) => {
    let filtered = uploadedDocuments.filter(
      (item: object) => getValue(item, `id`, '') !== id,
    );
    setUploadedDocuments(filtered);
  };
  /* -------------------------------------------------------------------------- */
  /*                                Prompt Section                              */
  /* -------------------------------------------------------------------------- */
  const [isChanged, setIsChanged] = useState(false);
  useEffect(() => {
    setIsChanged(
      _.isEqualWith(request, dirtyFields, (a: any, b: any) => {
        if ((_.isNull(a) || a === '') && (_.isNull(b) || b === '')) return true;
      }),
    );
  }, []);

  const [showPrompt, confirmNavigation, cancelNavigation]: any =
    useCallbackPrompt(!isChanged);

  // ----------------- Upload section ----------------- //
  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    e.preventDefault();
    const files = Array.from(e.target.files);

    setUploadLoading(true);

    try {
      for (const item of files) {
        const formData = new FormData();
        formData.append('file', item as any);

        try {
          const resp = await clientAdminFileUpload(formData); // waits here

          if (resp) {
            uploadedDocuments.push(getValue(resp, `data`, {}));
            setUploadedDocuments([...uploadedDocuments]);
          }
        } catch (error) {
          console.error('Upload error:', error);
        }
      }
    } finally {
      e.target.value = null;
      setUploadLoading(false);
    }
  };

  const handleDrop = (e: any) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    files.forEach(async (item: any) => {
      let formData = new FormData();
      formData.append('file', item);
      try {
        setUploadLoading(true);
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          uploadedDocuments.push(getValue(resp, `data`, {}));
          setUploadedDocuments([...uploadedDocuments]);
          e.target.value = null;
          setUploadLoading(false);
        } else {
          e.target.value = null;
        }
      } catch (error) {
        e.target.value = null;
        setUploadLoading(false);
      }
    });
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };
  const disableUpload = () => { };

  const approvalList = [
    { label: 'RE_OPENED', value: 'RE_OPENED' },
    { label: 'APPROVED', value: 'APPROVED' },
  ];

  let user: any = JSON.parse(getValue(localStorage, `user`, ''));
  const isAssignedUser = request?.assigned_user_id === user?.id;
  useEffect(() => {
    if (request.expiry_date && reminder_date) {
      const expiry = new Date(request.expiry_date);
      const followup = new Date(expiry);
      followup.setDate(expiry.getDate() - Number(reminder_date));
      setRequest((prev: any) => ({
        ...prev,
        follow_up_date: followup,
      }));
    }
  }, [request.expiry_date, reminder_date]);

  const [isLifeTimeTask, setIsLifeTimeTask] = useState(false);
  useEffect(() => {
    setIsLifeTimeTask(request.is_no_expiry_task);
  }, [request.is_no_expiry_task]);

  const [isExpiryDateRequired, setIsExpiryDateRequired] = useState(false);
  useEffect(() => {
    const isRequired =
      (request.license_status === 'COMPLIED' ||
        request.license_status === 'EXPIRED' ||
        request.license_status === 'ACTIVE') &&
      !isLifeTimeTask;
    setIsExpiryDateRequired(isRequired);
  }, [isLifeTimeTask, request.license_status]);

  useEffect(() => {
    if (simpleValidator.current) {
      simpleValidator.current.hideMessages();
      simpleValidator.current.fields = {};
    }
    forceUpdate((p: any) => p + 1);
  }, [isExpiryDateRequired, isLifeTimeTask]);

  const handleShowSaveButton = () => {
    const isAdmin = getValue(props, `permissions`, []).includes('view_all');
    const isApproved = getValue(info, `approved_status`, '') === 'APPROVED';
    const isAssignedUser =
      request?.assigned_user_id === user?.id ||
      request.assigned_evaluator === user?.id;
    if (!isAdmin && isApproved && isAssignedUser) return false;
    else return true;
  };

  const [count, setCount] = useState(0);
  const handleNotApplicable = (status: string) => {
    if (status === 'NOT_APPLICABLE') {
      setCount(1);
      setRequest((prev: any) => {
        const preservedKeys = [
          'approved_status',
          'license_status',
          'assigned_evaluator',
          'assigned_user_id',
          'completion_date',
          'is_no_expiry_task',
          'work_status',
        ];
        const cleared = Object.fromEntries(
          Object.entries(prev).map(([key, value]) => [
            key,
            preservedKeys.includes(key)
              ? key === 'work_status'
                ? null
                : value
              : '',
          ]),
        );
        return cleared;
      });
      setUploadedDocuments([]);
      setReminder_date(null);
    } else if (count > 0) {
      setCount(0);
      getData();
    }
  };

  return (
    <>
      <Layout>
        {!loading &&
          !getValue(props, `subTabPermissionList`, []).includes(
            'activities_licenses',
          ) ? (
          <NoAccessPage />
        ) : (
          <>
            <PromptModal
              showDialog={showPrompt}
              confirmNavigation={confirmNavigation}
              cancelNavigation={cancelNavigation}
            />
            <TaskLicenseNavigation
              id={params.id}
              checkpoint_id={params.checkpoint_id}
              locationId={params.locationId}
              license_type_id={params.license_type_id}
              handleSubmit={handleSubmit}
              submitLoading={submitLoading}
              save={handleShowSaveButton()}
              isChanged={isChanged}
              permissions={props.permissions}
              group_id={URLparams.group_id}
              region_id={URLparams.region_id}
            />
            <div className="map-vendor-wrapper map-vendor-wrapper--task-details w-100">
              <div className="map-vendor__details map-vendor__details--task-details d-flex align-items-flex-start px-0 my-0">
                {loading || !props.permissionAPITriggered ? (
                  <Loader />
                ) : (
                  <>
                    <TaskDetailsCommon data={data} />
                    <div className="map-vendor__check map-vendor__check--task-details">
                      <h4 className="map-vendor__task-title">
                        Task ID - {getValue(info, `license_task_id`, '')}{' '}
                      </h4>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          License Status
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Enter Work Status"
                          className="form-control w-100"
                          name="license_status"
                          id="license_status"
                          value={complianceStatusList.filter(
                            (item) =>
                              item.value ===
                              getValue(request, `license_status`, ''),
                          )}
                          options={complianceStatusList}
                          onChange={(e: any) => {
                            setRequest({
                              ...request,
                              license_status: e.value,
                              work_status:
                                e.value === 'ACTIVE'
                                  ? ''
                                  : e.value === 'COMPLIED' ||
                                    e.value === 'EXPIRED'
                                  ? 'COMPLETED'
                                  : request.license_status === 'EXPIRED' &&
                                    e.value !== 'EXPIRED'
                                    ? 'NEW'
                                    : request.work_status,
                            });
                            handleNotApplicable(e.value);
                          }}
                          label="Work Status"
                          disabled={
                            getValue(request, `approved_status`, '') ===
                            'APPROVED'
                          }
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Approval Status
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Select Approval Status"
                          className="form-control w-100"
                          name="approved_status"
                          id="approved_status"
                          value={approvalList.filter(
                            (item) =>
                              item.value ===
                              getValue(request, `approved_status`, ''),
                          )}
                          options={approvalList}
                          onChange={(e: any) =>
                            setRequest({
                              ...request,
                              approved_status: e.value,
                              license_status:
                                e.value === 'RE_OPENED'
                                  ? 'PENDING'
                                  : (info as any).license_status !== 'PENDING'
                                    ? (info as any).license_status
                                    : request.license_status,
                            })
                          }
                          label="Approval Status"
                          disabled={isAssignedUser || !handleShowSaveButton()}
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Internal Work Status
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Enter Internal Work Status"
                          className="form-control w-100"
                          name="work_status"
                          id="work_status"
                          value={workStatus.filter(
                            (item) =>
                              item.value ===
                              getValue(request, `work_status`, ''),
                          )}
                          options={workStatus}
                          onChange={(e: any) =>
                            setRequest({
                              ...request,
                              work_status: e.value,
                            })
                          }
                          label="Internal Work Status"
                          disabled={
                            getValue(request, `approved_status`, '') ===
                            'APPROVED' ||
                            getValue(request, `license_status`, '') ===
                            'NOT_APPLICABLE'
                          }
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <div className="d-flex justify-content-between">
                          <label className="checkpoint-active-details__label">
                            Expiry/Renewal Date
                            {isExpiryDateRequired && (
                              <span className="text-danger"> *</span>
                            )}
                          </label>
                          <div className="uploaded-details-wrapper-form-group form-group mb-2 d-flex align-items-center">
                            <label className="checkpoint-active-details__label  mx-2 ml-0 mb-0">
                              Lifetime:
                            </label>
                            <label
                              className="m-0 position-relative"
                              htmlFor={`index$`}
                            >
                              <input
                                type="checkbox"
                                className="default-checkbox"
                                id={`index$`}
                                checked={getValue(
                                  request,
                                  `is_no_expiry_task`,
                                  false,
                                )}
                                onChange={(e: any) =>
                                  setRequest({
                                    ...request,
                                    is_no_expiry_task:
                                      !request.is_no_expiry_task,
                                  })
                                }
                                disabled={
                                  getValue(request, `approved_status`, '') ===
                                  'APPROVED'
                                }
                              />
                              <div className="custom-checkbox">
                                <img
                                  src="/images/uploaded-details/tick.svg"
                                  className="img-fluid uploaded-tick"
                                  alt=""
                                />
                              </div>
                            </label>
                          </div>
                        </div>
                        {/* {!isLifeTimeTask && (
                          <InputField
                            inputType="DATETYPE-DOB"
                            placeholderText="Enter Followup Date"
                            className="form-control  w-100"
                            name="expiry_date"
                            id="expiry_date"
                            onChange={(e: any) =>
                              setRequest({
                                ...request,
                                expiry_date: e,
                              })
                            }
                            value={getValue(request, `expiry_date`, '')}
                            label="Expiry Date"
                            disabled={
                              getValue(request, `approved_status`, '') ===
                              'APPROVED' ||
                              getValue(request, `license_status`, '') ===
                              'NOT_APPLICABLE'
                            }
                            minDate={new Date()}
                            validator={
                              isExpiryDateRequired && !isLifeTimeTask
                                ? simpleValidator
                                : null
                            }
                          />
                        )} */}
                        {!isLifeTimeTask && (
                          <div className="user-details-wrapper__form-group form-group">
                            {getValue(request, `license_status`, '') === 'EXPIRED' ? (
                              <InputField
                                key="expired-date-input"
                                inputType="DATETYPE-DOB"
                                placeholderText="Enter Expiry Date"
                                className="form-control w-100"
                                name="expiry_date"
                                id="expiry_date"
                                onChange={(e: any) =>
                                  setRequest({
                                    ...request,
                                    expiry_date: e,
                                  })
                                }
                                value={getValue(request, `expiry_date`, '')}
                                label="Expiry/Renewal Date"
                                disabled={
                                  getValue(request, `approved_status`, '') === 'APPROVED' ||
                                  getValue(request, `license_status`, '') === 'NOT_APPLICABLE'
                                }
                                validator={
                                  isExpiryDateRequired && !isLifeTimeTask
                                    ? simpleValidator
                                    : null
                                }
                              />
                            ) : (
                              <InputField
                                key="active-date-input"
                                inputType="DATETYPE-DOB"
                                placeholderText="Enter Expiry Date"
                                className="form-control w-100"
                                name="expiry_date"
                                id="expiry_date"
                                onChange={(e: any) =>
                                  setRequest({
                                    ...request,
                                    expiry_date: e,
                                  })
                                }
                                value={getValue(request, `expiry_date`, '')}
                                label="Expiry/Renewal Date"
                                disabled={
                                  getValue(request, `approved_status`, '') === 'APPROVED' ||
                                  getValue(request, `license_status`, '') === 'NOT_APPLICABLE'
                                }
                                minDate={new Date()}
                                validator={
                                  isExpiryDateRequired && !isLifeTimeTask
                                    ? simpleValidator
                                    : null
                                }
                              />
                            )}
                          </div>
                        )}
                      </div>

                      {!isLifeTimeTask && (
                        <div className="user-details-wrapper__form-group form-group">
                          <label className="checkpoint-active-details__label">
                            Renewal Remainder Before
                            {isExpiryDateRequired && (
                              <span className="text-danger"> *</span>
                            )}
                          </label>
                          <InputField
                            inputType="INPUT_REACT_SELECT"
                            placeholder="Enter Renewal Remainder Before"
                            className="form-control w-100"
                            name="follow_up_date"
                            id="follow_up_date"
                            value={daysList.filter(
                              (item: any) => item.value == reminder_date,
                            )}
                            options={daysList}
                            onChange={(e: any) => setReminder_date(e.value)}
                            label="follow_up_date"
                            disabled={
                              getValue(request, `approved_status`, '') ===
                              'APPROVED' ||
                              getValue(request, `license_status`, '') ===
                              'NOT_APPLICABLE'
                            }
                            validator={
                              isExpiryDateRequired && !isLifeTimeTask
                                ? simpleValidator
                                : null
                            }
                          />
                        </div>
                      )}

                      {!isLifeTimeTask && (
                        <div className="user-details-wrapper__form-group form-group">
                          <label className="checkpoint-active-details__label">
                            Followup Date
                            {isExpiryDateRequired && (
                              <span className="text-danger"> *</span>
                            )}
                          </label>
                          <InputField
                            inputType="DATETYPE-DOB"
                            placeholderText="Enter Followup Date"
                            className="form-control w-100"
                            name="follow_up_date"
                            id="follow_up_date"
                            onChange={(e: any) =>
                              setRequest({
                                ...request,
                                follow_up_date: e,
                              })
                            }
                            value={getValue(request, `follow_up_date`, '')}
                            label="Followup Date"
                            disabled={
                              getValue(request, `approved_status`, '') ===
                              'APPROVED' ||
                              getValue(request, `license_status`, '') ===
                              'NOT_APPLICABLE'
                            }
                            validator={
                              isExpiryDateRequired ? simpleValidator : null
                            }
                          />
                        </div>
                      )}

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Completion Date
                        </label>
                        <InputField
                          inputType="DATETYPE-DOB"
                          placeholderText="Enter Completion Date"
                          className="form-control w-100"
                          name="completion_date"
                          id="completion_date"
                          onChange={(e: any) =>
                            setRequest({
                              ...request,
                              completion_date: e,
                            })
                          }
                          value={getValue(request, `completion_date`, '')}
                          label="Completion Date"
                          disabled={
                            getValue(request, `approved_status`, '') ===
                            'APPROVED'
                          }
                          validator={
                            getValue(request, `license_status`, '') ===
                              'COMPLIED' ||
                            getValue(request, `license_status`, '') ===
                              'ACTIVE'
                              ? simpleValidator
                              : null
                          }
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          License Number
                        </label>
                        <InputField
                          inputType="TEXT"
                          placeholder="Enter License Number"
                          className="form-control w-100"
                          name="license_number"
                          id="license_number"
                          value={getValue(request, `license_number`, '')}
                          onChange={(e: any) =>
                            setRequest({
                              ...request,
                              license_number: sanitizeInput(e.target.value),
                            })
                          }
                          label="License Number"
                          disabled={
                            getValue(request, `approved_status`, '') ===
                            'APPROVED' ||
                            getValue(request, `license_status`, '') ===
                            'NOT_APPLICABLE'
                          }
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Issuing Authority
                        </label>
                        <InputField
                          inputType="TEXT"
                          placeholder="Enter Issuing Authority"
                          className="form-control w-100"
                          name="issuing_authority"
                          id="issuing_authority"
                          value={getValue(request, `issuing_authority`, '')}
                          onChange={(e: any) =>
                            setRequest({
                              ...request,
                              issuing_authority: sanitizeInput(e.target.value),
                            })
                          }
                          label="Issuing Authority"
                          disabled={
                            getValue(request, `approved_status`, '') ===
                            'APPROVED' ||
                            getValue(request, `license_status`, '') ===
                            'NOT_APPLICABLE'
                          }
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Issued To/Competent Person
                        </label>
                        <InputField
                          inputType="TEXT"
                          placeholder="Enter Issued To"
                          className="form-control w-100"
                          name="issued_to"
                          id="issued_to"
                          value={getValue(request, `issued_to`, '')}
                          onChange={(e: any) =>
                            setRequest({
                              ...request,
                              issued_to: sanitizeInput(e.target.value),
                            })
                          }
                          label=" Issued To"
                          disabled={
                            getValue(request, `approved_status`, '') ===
                            'APPROVED' ||
                            getValue(request, `license_status`, '') ===
                            'NOT_APPLICABLE'
                          }
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Entity Name
                        </label>
                        <InputField
                          inputType="TEXT"
                          placeholder="Enter Entity Name"
                          className="form-control w-100"
                          name="entity_name"
                          id="entity_name"
                          value={getValue(request, `entity_name`, '')}
                          onChange={(e: any) =>
                            setRequest({
                              ...request,
                              entity_name: sanitizeInput(e.target.value),
                            })
                          }
                          label="Entity Name"
                          disabled={
                            getValue(request, `approved_status`, '') ===
                            'APPROVED' ||
                            getValue(request, `license_status`, '') ===
                            'NOT_APPLICABLE'
                          }
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <CustomFileUpload
                          handleDrop={handleDrop}
                          uploadLoading={uploadLoading}
                          disableUpload={disableUpload}
                          permissions={getValue(props, `permissions`, [])}
                          handleDragOver={handleDragOver}
                          handleUploadDocuments={handleUploadDocuments}
                          isDisabled={
                            getValue(request, `approved_status`, '') ===
                            'APPROVED' ||
                            getValue(request, `license_status`, '') ===
                            'NOT_APPLICABLE'
                          }
                        />

                        {getValue(uploadedDocuments, `length`, 0) > 0
                          ? uploadedDocuments.map(
                            (item: object, key: number) => {
                              return (
                                <div
                                  key={key}
                                  className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between"
                                >
                                  <p
                                    className="cursor-pointer"
                                    onClick={() =>
                                      handleDownloadOnClick(
                                        getValue(item, `url`, ''),
                                        getValue(item, `name`, ''),
                                      )
                                    }
                                  >
                                    {getValue(item, `name.length`, '') > 30
                                      ? getValue(item, `name`, '')
                                        .substring(0, 30)
                                        .concat('...')
                                      : getValue(item, `name`, '')}
                                  </p>
                                  {getValue(
                                    props,
                                    `permissions`,
                                    [],
                                  ).includes('update') && (
                                      <img
                                        src="/images/close-black.svg"
                                        className="img-fluid cursor-pointer"
                                        onClick={() => {
                                          if (
                                            getValue(
                                              request,
                                              'approved_status',
                                              '',
                                            ) !== 'APPROVED'
                                          ) {
                                            handleRemoveUploadedFiles(
                                              getValue(item, 'id', ''),
                                            );
                                          }
                                        }}
                                        alt="close"
                                      />
                                    )}
                                </div>
                              );
                            },
                          )
                          : ''}
                        <div>
                          <UncontrolledAccordion
                            open="2"
                            defaultOpen="2"
                            className="additional-information-accordion-wrap"
                          >
                            <AccordionItem>
                              <AccordionHeader targetId="2">
                                <div className="accordian-header-wrap d-flex align-items-center">
                                  <ApprovalFlowSvgComponent />
                                  <div className="accordion-header-title">
                                    Approval Flow
                                  </div>
                                </div>
                              </AccordionHeader>
                              <AccordionBody accordionId="2">
                                <div className="org-info-body-wrap">
                                  <div className="org-info d-flex align-items-center approval-flow-info is-arrow ">
                                    <span className="border-arrow-holder"></span>
                                    <div
                                      className="approval-profile-wrap"
                                      style={{
                                        background: '#1D4D40',
                                        border: '1px solid #1D4D40',
                                      }}
                                    >
                                      <span className="m-auto">
                                        {getValue(
                                          info,
                                          `assigned_to.first_name`,
                                          '',
                                        ).charAt(0).length > 0
                                          ? getValue(
                                            info,
                                            `assigned_to.first_name`,
                                            '',
                                          )
                                            .charAt(0)
                                            .toUpperCase()
                                          : 'A'}
                                      </span>
                                    </div>
                                    <div className="org-info-label-value-wrap approval-flow-label-value-wrap w-100">
                                      <div className="d-flex justify-content-between">
                                        <div>
                                          <div className="org-info-label">
                                            Executor
                                          </div>

                                          <div className="org-info-value">
                                            {getValue(
                                              info,
                                              `assigned_to.first_name`,
                                              '',
                                            ) +
                                              ' ' +
                                              getValue(
                                                info,
                                                `assigned_to.last_name`,
                                                '',
                                              )}
                                            <br />
                                            {getValue(
                                              info,
                                              `assigned_to.email`,
                                              '',
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="org-info d-flex align-items-center approval-flow-info is-arrow ">
                                    <span className="border-arrow-holder"></span>
                                    <div
                                      className="approval-profile-wrap"
                                      style={{
                                        background: '#D7242E',
                                        border: '1px solid #D7242E',
                                      }}
                                    >
                                      <span className="m-auto">
                                        {getValue(
                                          info,
                                          `assigned_evaluator.first_name`,
                                          '',
                                        ).charAt(0).length > 0
                                          ? getValue(
                                            info,
                                            `assigned_evaluator.first_name`,
                                            '',
                                          )
                                            .charAt(0)
                                            .toUpperCase()
                                          : 'A'}
                                      </span>
                                    </div>
                                    <div className="org-info-label-value-wrap approval-flow-label-value-wrap w-100">
                                      <div className="d-flex justify-content-between">
                                        <div>
                                          <div className="org-info-label">
                                            Evaluator
                                          </div>

                                          <div className="org-info-value">
                                            {getValue(
                                              info,
                                              `assigned_evaluator.first_name`,
                                              '',
                                            ) +
                                              ' ' +
                                              getValue(
                                                info,
                                                `assigned_evaluator.last_name`,
                                                '',
                                              )}
                                            <br />
                                            {getValue(
                                              info,
                                              `assigned_evaluator.email`,
                                              '',
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </AccordionBody>
                            </AccordionItem>
                          </UncontrolledAccordion>
                        </div>

                        <div>
                          <UncontrolledAccordion
                            open="3"
                            defaultOpen="3"
                            className="additional-information-accordion-wrap"
                          >
                            <AccordionItem>
                              <AccordionHeader targetId="2">
                                <div className="accordian-header-wrap d-flex align-items-center">
                                  <EntityMappingSvgComponent />
                                  <div className="accordion-header-title">
                                    Location Mapping
                                  </div>
                                </div>
                              </AccordionHeader>
                              <AccordionBody accordionId="3">
                                <div className="org-info-body-wrap">
                                  <div className="org-info d-flex align-items-center approval-flow-info is-arrow ">
                                    <div className="org-info-label-value-wrap approval-flow-label-value-wrap w-100">
                                      <div className="d-flex justify-content-between">
                                        <div>
                                          <div className="org-info-label">
                                            Location
                                          </div>

                                          <div className="org-info-value">
                                            {getValue(
                                              data,
                                              `location.location_name`,
                                              '',
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="org-info d-flex align-items-center approval-flow-info is-arrow ">
                                    <div className="org-info-label-value-wrap approval-flow-label-value-wrap w-100">
                                      <div className="d-flex justify-content-between">
                                        <div>
                                          <div className="org-info-label">
                                            License Type
                                          </div>

                                          <div className="org-info-value">
                                            {getValue(
                                              data,
                                              `license_type.text`,
                                              '',
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </AccordionBody>
                            </AccordionItem>
                          </UncontrolledAccordion>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="w-100 footer-wrapper--task">
                <img
                  src="/images/footer-image.svg"
                  className="img-fluid footer-image"
                  alt=""
                />
              </div>
            </div>
          </>
        )}
      </Layout>
    </>
  );
}
